import React, { useMemo, memo } from 'react';
import { ReactComponent as Confirmed } from '../../assets/images/badge-confirmed.svg';
import { ReactComponent as Guaranteed } from '../../assets/images/badge-guaranteed.svg';
import { ReactComponent as Bundle } from '../../assets/images/badge-bundle.svg';
import { ReactComponent as Orientation } from '../../assets/images/badge-orientation.svg';
import { ReactComponent as Integrated } from '../../assets/images/badge-integrated.svg';
import SLOT_STATUSES from '../../constants/slotStatuses';
import Tooltip from '../../components/Tooltip/Tooltip';

import './SlotBadges.scss';
import { GLOBAL_CALENDAR_SHIFT_TYPES } from '../../constants';

const SlotBadges = ({ shift, slot }) => {
	const shouldShowBadges = useMemo(
		() =>
			slot.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT ||
			!!slot.is_guaranteed ||
			!!slot.contract_id ||
			!!shift.is_orientation ||
			!!slot.is_integrated,
		[shift, slot]
	);

	return (
		shouldShowBadges && (
			<div className="slot-badges__container">
				<div className="slot-badges__left">
					{slot.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT && shift.shift_type !== GLOBAL_CALENDAR_SHIFT_TYPES.FLEX && (
						<Tooltip label="Confirmed" placement="top">
							<Confirmed width={14} height={14} />
						</Tooltip>
					)}
				</div>
				<div className="slot-badges__right">
					{!!shift.is_orientation && (
						<Tooltip label="Orientation" placement="top">
							<Orientation />
						</Tooltip>
					)}
					{!!slot.is_integrated && (slot.caregiver_id === null || slot.has_assigned_slot_integrated) && (
						<Tooltip label="Integrated" placement="top">
							<Integrated />
						</Tooltip>
					)}
					{!!slot.contract_id && (
						<Tooltip label="Bundle" placement="top">
							<Bundle />
						</Tooltip>
					)}
					{!!slot.is_guaranteed && (
						<Tooltip label="Guaranteed" placement="top">
							<Guaranteed />
						</Tooltip>
					)}
				</div>
			</div>
		)
	);
};

export default memo(SlotBadges);
